module.exports = __webpack_public_path__ + "src/assets/vehicles/moped-scoot.svg";